<template>
  <div v-if="getShowTips" class="m-tips">
    <div class="m-header m-header--blue">
      <div class="m-header__start">
          <router-link class="m-header__link m-header__link--home" to="/">
            <img src="~@/assets/images/icon__home.png"/>
          </router-link>
        </div>
    </div>
    <div class="l-container">
      <div class="m-tips__box">
        <h4 class="m-tips__title">Tips</h4>
        <p>To win the game, you need to get promoted to Partner and keep within your budget.</p>
        <p>But watch out, you’ll only get promoted if you choose the best solution for the city,
           which isn’t always the cheapest option, so make sure to choose carefully.</p>
        <a @click="toggleShowTips" class="m-tips__close">X</a>
      </div>
    </div>
    <img src="~@/assets/images/rics-logo.png" class="m-logo m-logo--bottom-right" />
    <h4 class="m-brand m-logo m-logo--bottom-left">MEGA FUTURES</h4>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      showTips: false,
    };
  },
  computed: {
    ...mapGetters(['getShowTips']),
  },
  methods: {
    ...mapActions(['toggleShowTips']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tips.vue